import './LogoAndText.pcss';
import React from 'react';
import customersLogo from 'assets/logo-customers-blue.svg';

export const LogoAndText = () => (
  <div className="logo-and-text">
    <img
      src={customersLogo}
      alt="Customers.ai Logo"
      className="logo-and-text__logo-image"
    />
    <div className="logo-and-text__logo-name">Customers.ai</div>
  </div>
);
